import {interopDefault} from '@/utils/helpers'

const ExtraServicesPage = () => interopDefault(import('~src/pages/extraServices/ExtraServicesPage'))
const ExtraServicePage = () => interopDefault(import('~src/pages/extraServices/ExtraServicePage'))
const ExtraServiceBookingPage = () => interopDefault(import('~src/pages/extraServices/ExtraServiceBookingPage'))
const ExtraServiceConfirmationPage = () =>
    interopDefault(import('~src/pages/extraServices/ExtraServiceConfirmationPage'))

export default [
    {
        path: '/search/extra-services',
        component: ExtraServicesPage,
        name: 'extraServices',
        meta: {
            unwrapped: true,
            validate: route => !!route.query.cityId,
        },
    },
    {
        path: '/extra-service',
        component: ExtraServicePage,
        name: 'extraService',
        beforeEnter: (to, from, next) => {
            if (!to.query.name) {
                next({name: 'home'})
            }
            next()
        },
        meta: {
            unwrapped: true,
            validate: route => !!route.query.name,
        },
    },
    {
        path: '/extra-service/booking',
        component: ExtraServiceBookingPage,
        name: 'extraServiceBooking',
        beforeEnter: (to, from, next) => {
            if (!to.query.offerKey) {
                next({name: 'home'})
            }
            next()
        },
        meta: {
            unwrapped: true,
            validate: route => !!route.query.offerKey,
        },
    },
    {
        path: '/extra-service/confirmation',
        component: ExtraServiceConfirmationPage,
        name: 'extraServiceConfirmation',
        beforeEnter: (to, from, next) => {
            if (!to.query.orderId) {
                next({name: 'home'})
            }
            next()
        },
        meta: {
            unwrapped: true,
        },
    },
]
